import { render, staticRenderFns } from "./CallsIssues.vue?vue&type=template&id=68cc3fe1&scoped=true"
import script from "./CallsIssues.vue?vue&type=script&lang=js"
export * from "./CallsIssues.vue?vue&type=script&lang=js"
import style0 from "./CallsIssues.vue?vue&type=style&index=0&id=68cc3fe1&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cc3fe1",
  null
  
)

export default component.exports